import SummaryCard from "./summary-card";
import {
  Grid,
} from "@mui/material";
import {
  VolunteerActivism as DonateIcon,
  RequestQuote as NeedIcon,
  Handshake as MatchIcon,
  LocalOffer as OfferIcon,
} from "@mui/icons-material";

const SummaryCards = ({ 
    statistics,

}) => {
    return (
        <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
                <SummaryCard
                    title="Total Donations"
                    value={statistics?.donations?.total || 0}
                    icon={DonateIcon}
                    secondaryValue={`${statistics?.donations?.active || 0} active`}
                    color="success"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <SummaryCard
                    title="Total Needs"
                    value={statistics?.needs?.total || 0}
                    icon={NeedIcon}
                    secondaryValue={`${statistics?.needs?.active || 0} active`}
                    color="warning"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <SummaryCard
                    title="Completed Matches"
                    value={(statistics?.donations?.completed || 0) + (statistics?.needs?.completed || 0)}
                    icon={MatchIcon}
                    secondaryValue="Successfully matched"
                    color="primary"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <SummaryCard
                    title="Ready to Match"
                    value={(statistics?.donations?.active || 0) + (statistics?.needs?.active || 0)}
                    icon={OfferIcon}
                    secondaryValue={`${statistics?.donations?.active || 0} donations + ${statistics?.needs?.active || 0} needs`}
                    color="info"
                />
            </Grid>
        </Grid>
    );
}

export default SummaryCards;